// Hub page content for the Skilled Migration group.
// Sourced from docs/research/australian-visa-pathways.md §1.
// The service CARDS come from the registry (index.js); this file adds the
// hub intro, the at-a-glance comparison, the "how it works" explainer, and FAQs.

const skilledMigrationHub = {
  groupSlug: "skilled-migration",
  eyebrow: "Skilled Migration",
  heading: "Skilled migration to Australia",
  intro:
    "If you have skills Australia needs, the General Skilled Migration program can lead to permanent residence, with or without a sponsor. The right subclass depends on your occupation, your points, and whether you are open to a regional area. A registered migration agent assesses your realistic options, and we build your file to a lodgement standard and keep it moving.",

  // How the program works (shared across the points-tested visas).
  howItWorks: {
    heading: "How skilled migration works",
    steps: [
      {
        title: "Skills assessment",
        detail:
          "Your occupation is assessed by the relevant assessing authority. No assessment, no skilled visa.",
      },
      {
        title: "Expression of Interest",
        detail:
          "You lodge an EOI in SkillSelect with your points claim. You do not apply for the visa directly.",
      },
      {
        title: "Invitation",
        detail:
          "Invitations are issued in rounds. The Department invites for the 189; states and territories invite for the 190 and 491.",
      },
      {
        title: "Visa application",
        detail:
          "If invited, you lodge the visa within the time allowed. The Department decides the outcome.",
      },
    ],
  },

  // At-a-glance comparison (layout renders as a responsive table/cards).
  atAGlance: {
    heading: "Compare the skilled visas at a glance",
    columns: ["Visa", "Best for", "Result", "Sponsor or nomination"],
    rows: [
      {
        serviceSlug: "skilled-independent-189",
        cells: [
          "Skilled Independent (189)",
          "Competitive points, no sponsor needed",
          "Permanent residence",
          "None",
        ],
      },
      {
        serviceSlug: "skilled-nominated-190",
        cells: [
          "Skilled Nominated (190)",
          "A state wants your occupation",
          "Permanent residence",
          "State or territory (adds 5 points)",
        ],
      },
      {
        serviceSlug: "skilled-regional-491",
        cells: [
          "Skilled Work Regional (491)",
          "Open to living in a regional area",
          "Provisional, 5 years (pathway to 191)",
          "State or eligible relative (adds 15 points)",
        ],
      },
      {
        serviceSlug: "permanent-regional-191",
        cells: [
          "Permanent Residence Regional (191)",
          "Holders of a 491 who met the conditions",
          "Permanent residence",
          "None (not points-tested)",
        ],
      },
    ],
  },

  faqs: [
    {
      q: "Which skilled visa is right for me?",
      a: "It depends on your occupation, your points score, and whether you are willing to live in a regional area. The 189 needs no sponsor but is the most competitive. The 190 needs a state nomination and adds 5 points. The 491 adds 15 points but is regional and provisional. A registered migration agent assesses all of them for you, and we prepare the file behind whichever path you take.",
    },
    {
      q: "Do I need a skills assessment first?",
      a: "Yes. For almost every skilled visa you need a positive skills assessment for your nominated occupation from the relevant assessing authority before you can be invited. A registered migration agent confirms the right occupation and authority, and we organise and prepare the evidence they need.",
    },
    {
      q: "Can you guarantee I will be invited?",
      a: "No. Invitations depend on your points, your occupation, and the selection rounds run by the Department and the states. No one controls that. We make sure your evidence is accurate and organised, and a registered migration agent makes the points claim as strong as it honestly can be.",
    },
  ],

  lastVerified: "13 July 2026",
};

export default skilledMigrationHub;
